(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["makai-halloween-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('makai-seasonal-carousel')) {
    customElements.define('makai-seasonal-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.slides = [...this.querySelectorAll('[data-makai-slide]')];
        this.dots = [...this.querySelectorAll('[data-go]')];
        this.index = 0;
        if (this.slides.length < 2) return;
        this.paused = this.dataset.autoplay !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches || !!window.Shopify?.designMode;
        this.querySelector('.makai-carousel__controls').hidden = false;
        this.querySelector('[data-prev]').addEventListener('click', () => this.show(this.index - 1), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), options);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index), options));
        this.querySelector('[data-pause]').addEventListener('click', () => {this.paused = !this.paused; this.updatePause(); this.start();}, options);
        this.addEventListener('mouseenter', () => {this.hovered = true; this.start();}, options);
        this.addEventListener('mouseleave', () => {this.hovered = false; this.start();}, options);
        this.addEventListener('focusin', () => {this.focused = true; this.start();}, options);
        this.addEventListener('focusout', (event) => {if (!this.contains(event.relatedTarget)) {this.focused = false; this.start();}}, options);
        this.addEventListener('keydown', (event) => {if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));}}, options);
        this.addEventListener('touchstart', (event) => {this.touchX = event.touches[0].clientX; this.touchY = event.touches[0].clientY;}, {...options, passive:true});
        this.addEventListener('touchend', (event) => {const dx = event.changedTouches[0].clientX - this.touchX; const dy = event.changedTouches[0].clientY - this.touchY; if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) this.show(this.index + (dx < 0 ? 1 : -1));}, options);
        document.addEventListener('visibilitychange', () => this.start(), options);
        document.addEventListener('shopify:block:select', (event) => {const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target)); if (index >= 0) {this.paused = true; this.show(index); this.updatePause();}}, options);
        this.updatePause();
        this.start();
      }
      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, position) => {slide.hidden = position !== this.index; slide.inert = position !== this.index;});
        this.dots.forEach((dot, position) => dot.setAttribute('aria-current', String(position === this.index)));
        this.start();
      }
      updatePause() {
        const button = this.querySelector('[data-pause]');
        button.textContent = this.paused ? '▶' : 'Ⅱ';
        button.setAttribute('aria-label', this.paused ? 'Lancer le diaporama' : 'Mettre le diaporama en pause');
      }
      start() {
        clearTimeout(this.timer);
        if (!this.paused && !this.hovered && !this.focused && !document.hidden) this.timer = setTimeout(() => this.show(this.index + 1), Math.max(5000, Number(this.dataset.delay) || 10000));
      }
      disconnectedCallback() {clearTimeout(this.timer); this.abort?.abort(); this.ready = false;}
    });
  }
  } catch(e) { console.error(e); }
})();

})();
